import styled from 'styled-components';

import { Row } from 'enable-ui';

import { COLOR } from 'constants/color';
import { COLOR_CONFIG } from 'constants/color';

export const FilterWrapper = styled.section`
  padding: 32px 0 32px 32px;
  margin-top: -32px;
  height: 100vh;
  border-left: 1px solid rgba(0, 0, 0, 0.15);

  .text-input-wrapper {
    min-width: 312px;
    padding: 6px 12px;
    background: ${COLOR_CONFIG.white};
    margin-bottom: 32px;
  }

  .input-prefix {
    margin-left: 0;
  }

  .text-input {
    padding: 5px;

    &::placeholder {
      font-size: 16px;
      line-height: calc(22 / 16);
      color: ${COLOR_CONFIG['neutral-text']};
    }
  }

  .es-check-box-wrapper {
    padding: 0;

    div {
      padding: 0;
    }

    .checkbox {
      margin-right: 0;
    }
  }

  .custom-collapse {
    overflow-x: hidden;
    margin-bottom: 32px;
  }

  .ellipsis {
    max-width: 312px;
  }

  .dropdown {
    background: ${COLOR_CONFIG.white};

    .dropdown-item {
      background: ${COLOR_CONFIG.white};

      &:hover {
        background: ${COLOR.neutral['neutral-4']};
      }
    }
  }

  .value-select {
    font-size: 16px;
    line-height: calc(22 / 16);
    color: ${COLOR_CONFIG['neutral-text']};
  }

  .tippy-content {
    top: -22px;
  }
`;

export const MainTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  margin: 0 0 12px;
  color: ${COLOR.surfaceNeutralBold['neutral-11']};
`;

export const ItemWrapper = styled(Row)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CollapseWrapper = styled.div`
  overflow: auto;
  max-height: 820px;
`;

export const SelectStyle = {
  height: 22,
};

export const SelectInputStyle = {
  border: 'none',
  background: COLOR_CONFIG.white,
  boxShadow: 'none',
  height: 22,
  maxWidth: 312,
  transform: 'translateY(-12px)',
  justifyContent: 'flex-start',
};
